import { t } from "i18next";
import { EVENT_LINK_APP, EVENT_LINK_PLAYSTORE, EVENT_LINK_WHATSAPP, REDIRECT_URL, sendTapEvent, toIndoFormat, WHATSAPP_LINK } from "../helper/helper";
import { ReactComponent as Check } from "../rsc/check.svg";
import { colorPrimary, colorPrimaryDark } from "../rsc/colors";
import { ReactComponent as Mobile } from "../rsc/mobile.svg";
import { ReactComponent as Open } from "../rsc/open.svg";
import GooglePlayStoreg from "../rsc/playstore.png";
import Whatsapp from "../rsc/whatsapp.png";
import tbsgroup1 from "../rsc/tbsgroup1.png";
import tbsgroup2 from "../rsc/tbsgroup2.png";
import tbsgroup3 from "../rsc/tbsgroup3.png";
import "./ContactToSellMyFruit.scss";

type ContactType =
    | "mill"
    | "farm";

type Props = {
    price: number
    type: ContactType
    style?: React.CSSProperties
}

export function ContactToSellMyFruit({ price, type, style }: Props) {

    const styleCombined: React.CSSProperties = style ? style : { boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", borderRadius: "8px" }

    return (<div
        style={{
            ...styleCombined,
            display: "flex", flexDirection: "column", background: "#fff", padding: "20px", gap: "10px"
        }}>
        <div style={{ display: "flex", alignItems: "center" }}>
            <p className="text-big" style={{ color: colorPrimaryDark, fontWeight: 800 }}>{t('fetch_price_heading')}</p>
        </div>
        {
            type === "farm" ?
                <>
                    <p style={{ color: colorPrimaryDark, fontWeight: 800 }}>{t('fetch_price_subheading')}</p>

                    <div className="pricing-wrapper">
                        <div className="pricing-container">
                            <div className="pricing-item">
                                <div className="circle">
                                    <h2>3000 kg</h2>
                                    <img src={tbsgroup1} className="fruit-img" style={{ width: "50px" }} alt="Fruit Pile 3000kg" />
                                </div>
                                <div className="arrow">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 4V16" stroke="#00bcd4" stroke-width="4" stroke-linecap="round" />
                                        <path d="M6 12L12 20L18 12" stroke="#00bcd4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div className="price"><span className="text-smaller">Rp</span> {toIndoFormat((price ?? 0) * 3000)}</div>
                            </div>

                            <div className="pricing-item">
                                <div className="circle">
                                    <h2>5000 kg</h2>
                                    <img src={tbsgroup2} className="fruit-img" style={{ width: "80px" }} alt="Fruit Pile 5000kg" />
                                </div>
                                <div className="arrow">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 4V16" stroke="#00bcd4" stroke-width="4" stroke-linecap="round" />
                                        <path d="M6 12L12 20L18 12" stroke="#00bcd4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div className="price"><span className="text-smaller">Rp</span> {toIndoFormat((price ?? 0) * 5000)}</div>
                            </div>

                            <div className="pricing-item">
                                <div className="circle">
                                    <h2>10000 kg</h2>
                                    <img src={tbsgroup3} className="fruit-img" alt="Fruit Pile 10000kg" />
                                </div>
                                <div className="arrow">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 4V16" stroke="#00bcd4" stroke-width="4" stroke-linecap="round" />
                                        <path d="M6 12L12 20L18 12" stroke="#00bcd4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div className="price"><span className="text-smaller">Rp</span> {toIndoFormat((price ?? 0) * 10000)}</div>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "10px", marginTop: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <Check />
                            <p className="text-medium" style={{ padding: 0, margin: 0, color: "#079AA8", fontWeight: 600 }}>{t('transport_included')}</p>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "600" }}>
                            <Check />
                            <p className="text-medium" style={{ padding: 0, margin: 0, color: "#079AA8", fontWeight: "600" }}>{t('paid_directly_at_farm')}</p>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <Check />
                            <p className="text-medium" style={{ padding: 0, margin: 0, color: "#079AA8", fontWeight: "600" }}>{t('no_rejected_fruits')}</p>
                        </div>
                    </div>
                    <p>
                        <span style={{ color: colorPrimaryDark, fontWeight: 800 }}>{t('call_pempem_message')}</span> <span style={{ color: colorPrimaryDark, fontWeight: "600" }}>{t('download_pempem_app_instruction_for_price')}</span>
                    </p>
                </>
                :
                <>
                    <p className="text-big" style={{ color: colorPrimaryDark, fontWeight: 700 }}>{t('call_pempem_message_part_2')}</p>
                </>
        }

        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
        }}>
            <a
                href={WHATSAPP_LINK}
                style={{ textDecoration: "none" }}
                onClick={() => sendTapEvent(EVENT_LINK_WHATSAPP)}
            >
                <img
                    alt="WhatsApp"
                    src={Whatsapp}
                    height="45px"
                    className="whatsapp-button"
                />
            </a>

            <a
                href={REDIRECT_URL}
                onClick={() => sendTapEvent(EVENT_LINK_PLAYSTORE)}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "8px",
                        height: "60px",
                        cursor: "pointer"
                    }}
                >
                    <img src={GooglePlayStoreg} className="play-button" alt="Google Play" />
                </div>
            </a>
        </div>

        {
            type === "mill" &&
            <a href={REDIRECT_URL} style={{ textDecoration: "none" }} onClick={() => sendTapEvent(EVENT_LINK_APP)}>
                <div className="gradient-background-white-blue"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        border: `solid 2px ${colorPrimary}`,
                        borderRadius: "8px",
                        height: "56px",
                        gap: "10px", alignItems: "center", cursor: "pointer"
                    }} >
                    <Mobile />
                    <p className="text-very-big" style={{ fontWeight: "600", color: colorPrimaryDark, textDecoration: "none" }}>{t('launch_app')}</p>
                    <Open />
                </div>
            </a>
        }
    </div>)
}